import { format } from 'date-fns/esm';
import { ru } from 'date-fns/esm/locale';

export const getFreeText = (abGroup: string | null, freeDate: string) => {
  if (!freeDate) {
    return '';
  }

  const dateText = format(new Date(freeDate), 'd MMMM', { locale: ru });

  if (abGroup === 'C') {
    return `Услуга действует до ${dateText}`;
  }

  return `Бесплатно до ${dateText}`;
};
